import { UserException } from '@/domain/user/exception/UserException'

export class InvalidLastNameException extends UserException {

}
